import React from 'react';
import {
  Box,
  Button,
  Icons,
  Typography,
  useTheme,
} from '@ublend-npm/aulaui-core';
import {
  getBackButtonRoute,
  goToMySpaceNav,
} from '@core/constants/backButtonNavigation';
import pushRoute from '@app/utils/routing';
import commonRoomIcon from '@static/common_room.svg';
import { createStyles } from './CommonRoomResponsive.styles';
import ParticipantsPreview from './ParticipantsPreview/ParticipantsPreview';
import type { ParticipantsPreviewParticipant } from './ParticipantsPreview/ParticipantsPreview.types';

interface CommonRoomSidebarProps {
  participantTotal: number;
  participants: ParticipantsPreviewParticipant[];
  spaceId?: string;
}

const CommonRoomSidebar = ({
  participantTotal,
  participants,
  spaceId,
}: CommonRoomSidebarProps) => {
  const theme = useTheme();
  const styles = createStyles(theme);
  const backRoute =
    getBackButtonRoute() || (spaceId && goToMySpaceNav(spaceId));

  const handleBack = () => {
    if (backRoute) pushRoute(backRoute);
  };

  return (
    <Box component="aside" sx={styles.sidebar} aria-label="Common Room">
      <Button
        kind="secondary"
        onClick={handleBack}
        disabled={!backRoute}
        startIcon={<Icons.WestOutlined aria-hidden="true" />}
        aria-label="Back to space navigation"
        sx={styles.backButton}
      >
        Back
      </Button>

      <Box sx={styles.titleRow}>
        <Box sx={styles.titleIcon} aria-hidden="true">
          <img
            src={commonRoomIcon}
            alt=""
            width="40"
            height="40"
            data-testid="common-room-icon"
          />
        </Box>
        <Typography component="h1" variant="h5" sx={styles.title}>
          Common room
        </Typography>
      </Box>

      <ParticipantsPreview
        participantTotal={participantTotal}
        participants={participants}
      />
    </Box>
  );
};

export default CommonRoomSidebar;
